<template>
  <div class="full" ref="fuller" :style="{ opacity: opacity }">
    <!-- <div ref="display" class="display" /> -->
    <div ref="mathJaxEl" class="display" v-html="html" />
  </div>
</template>

<script>
// import Prism from 'prismjs'
// import hljs from 'highlight.js'
var hljs = require('highlight.js')

export default {
  props: {
    placeholder: {
      default: ''
    },
    latex: {
      default: `$$Hello$$
From \\( PALMS\\) \\(Team\\)
$$ \\sqrt2 $$
This is inline math equation \\( \\int ^{10}_{0}awesome \\)`,
      required: true
    }
  },
  data() {
    return {
      rendererIsReady: false,
      timer: null,
      opacity: 0,
      html: ''
    }
  },
  watch: {
    latex() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.renderLatex()
      }, 350)

      // clearInterval(this.timer)
      // this.timer = setInterval(() => {
      //   if (this.rendererIsReady) {
      //     clearInterval(this.timer)
      //     this.renderLatex()
      //   }
      // }, 350)
    }
  },
  mounted() {
    this.html = this.placeholder
    this.renderLatex()
  },
  methods: {
    highlight () {
      this.$nextTick(() => {
        document.querySelectorAll('pre code').forEach((block) => {
          if (block.innerHTML.indexOf('\n') === 0) {
            block.innerHTML = block.innerHTML.replace('\n', '')
          }
          hljs.highlightBlock(block)
          console.log(block)
        })
      })
    },
    renderLatex() {
      // if (!this.$refs['mathJaxEl']) {
      //   return
      // }
      this.rendererIsReady = false
      this.opacity = 0
      let mathJaxEl = this.$refs['mathJaxEl']
      // mathJaxEl.style.visibility = 'hidden'
      mathJaxEl.innerHTML = `${this.latex}`
      window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, mathJaxEl, () => {
        this.highlight()
        let opai = 0
        let tt = setInterval(() => {
          opai += 0.1
          this.opacity = opai

          if (opai >= 1) {
            this.rendererIsReady = true
            clearInterval(tt)
          }
        }, 16.7)
        // this.$nextTick(() => {
        //   if (this.$refs.display) {
        //     // this.$refs.display.innerHTML = mathJaxEl.innerHTML
        //     // mathJaxEl.style.visibility = 'visible'
        //     // this.highlight()
        //   }
        // })
      }])
    }
  }
}
</script>
<style>
/*rainbow*/
.hljs{display:block;overflow-x:auto;padding:.5em;background:#474949;color:#d1d9e1}.hljs-comment,.hljs-quote{color:#969896;font-style:italic}.hljs-keyword,.hljs-selector-tag,.hljs-literal,.hljs-type,.hljs-addition{color:#cc99cc}.hljs-number,.hljs-selector-attr,.hljs-selector-pseudo{color:#f99157}.hljs-string,.hljs-doctag,.hljs-regexp{color:#8abeb7}.hljs-title,.hljs-name,.hljs-section,.hljs-built_in{color:#b5bd68}.hljs-variable,.hljs-template-variable,.hljs-selector-id,.hljs-class .hljs-title{color:#ffcc66}.hljs-section,.hljs-name,.hljs-strong{font-weight:bold}.hljs-symbol,.hljs-bullet,.hljs-subst,.hljs-meta,.hljs-link{color:#f99157}.hljs-deletion{color:#dc322f}.hljs-formula{background:#eee8d5}.hljs-attr,.hljs-attribute{color:#81a2be}.hljs-emphasis{font-style:italic}
</style>

<style scoped>
/* @import url('highlight.js/styles/github.css'); */
.full{
  height: 100%;
}
.maximizer{
  height: 100%;
}
.display{
  height: 100%;
  white-space: pre-line;
}
</style>
